import {} from 'clsx'
import { type ClassValue, clsx } from 'clsx'
import { differenceInDays, format, isToday, isYesterday } from 'date-fns'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const setGlobalCSSVar = (name: string, value: string) => {
  document.documentElement.style.setProperty(name, value)
}

export function formatMessageDate(date: string | Date | number) {
  const messageDate = new Date(date)

  if (isToday(messageDate)) return 'Today'
  if (isYesterday(messageDate)) return 'Yesterday'

  const dayDiff = differenceInDays(new Date(), messageDate)
  if (dayDiff < 20) {
    return `${dayDiff} days ago`
  }

  return format(messageDate, 'MMMM d, yyyy')
}

export const getThreeRandomStringsFromArray = (strings: string[] | undefined | null) => {
  if (!strings || !Array.isArray(strings)) return []

  const shuffled = [...strings].sort(() => Math.random() - 0.5)
  const firstThree = shuffled.slice(0, 3)
  const sorted = [...firstThree].sort((a, b) => a.length - b.length)

  return sorted
}

export const getCacheTag = (replicaUuid: string) => {
  return `replica-${replicaUuid}`
}
